import { Result } from '../../assets/src/utils/Result';
import { Deferred, deferred } from '../../assets/src/utils/deferred';
import { IPlatformPreloader, loadScriptWithRetries, stringifyValue } from './IPlatformPreloader';

export class CrazyGamesPlatformPreloader implements IPlatformPreloader {
	private _initialized = false;
	private _initCompleted: Deferred<Result>;

	public get initialized(): boolean {
		return this._initialized;
	}

	public set initialized(value: boolean) {
		this._initialized = value;
	}

	public async loadAndInit(): Promise<Result> {
		if (this._initCompleted) {
			return this._initCompleted.promise;
		}

		const sdkLoaded = await loadScriptWithRetries('//sdk.crazygames.com/crazygames-sdk-v3.js');
		if (sdkLoaded.success === false) {
			return Result.Error(sdkLoaded.error);
		}

		if (!('CrazyGames' in window)) {
			return Result.Error(`script was loaded but CrazyGames SDK is not available`);
		}

		this._initCompleted = deferred<Result>();

		CrazyGames.SDK.init()
			.then(() => {
				CrazyGames.SDK.game.loadingStart();
				this._initialized = true;
				this._initCompleted.resolve(Result.Ok());
			})
			.catch((error) => {
				this._initCompleted.resolve(Result.Error(stringifyValue(error)));
			});

		return this._initCompleted.promise;
	}

	public setLoadingProgress(progress: number): void {
		// ничего не делаем, используется в платформах, где есть свой загрузчик
	}
}
